<template>
    <div class="w-full bg-background-basic-1">
        <table class="w-full table-fixed">
            <colgroup>
                <col class="w-[140px]" />
                <col class="w-[100px]" />
                <col class="w-[80px]" />
                <col class="w-[140px]" />
                <col />
            </colgroup>
            <thead>
                <tr>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Date</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Type</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Hours</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Basic Hourly Wage</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Deduct Amount</th>
                </tr>
            </thead>
            <tbody class="bg-background-basic-1">
                <tr
                    v-for="(detail, index) in deductAmountDetailList"
                    v-bind:key="detail.__key || index"
                    :class="{ 'border-t border-border-basic-1': index > 0 }"
                >
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">
                        <template v-if="detail.__rowType === 'WEEKLY'">
                            {{ fitDateFormat(detail.periodFrom, 'MM/DD/YYYY') }} ~ {{ fitDateFormat(detail.periodTo, 'MM/DD/YYYY') }}
                        </template>
                        <template v-else>
                            {{ detail.deductDate }}
                        </template>
                    </td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-accent-red-3">{{ detail.deductType }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ getHHmmStrFromMin(detail.deductHours) }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ fitDecimalFormatWithComma(detail.hourlyWageAmount, 5) }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ fitDecimalFormatWithComma(detail.deductAmount, 5) }}</td>
                </tr>
            </tbody>
        </table>
        <div class="flex w-full items-center justify-end gap-3 border-t border-border-basic-2 bg-background-basic-1 px-6 pb-8 pt-6 font-body-md-regular whitespace-nowrap">
            <p class="text-content-basic-2">Total Deduct Amount :</p>
            <p class="font-body-md-semibold text-primary-3">{{ fitDecimalFormatWithComma(getTotalDeductAmount()) }}</p>
        </div>
    </div>
</template>

<script>
import { NumberFormatUtil, DateFormatUtil } from "@/plugins/app-util";

export default {
    components :{
    },
    emits : ['update:modelValue', 'afterClose'],
    props : {
        modelValue : Boolean,
        deductAmountDetailList : Array
    },
    data(){
        return {
        }
    },
    mounted() {
    },
    methods : {
        hidePopup() {
            const self = this;
            self.$emit('update:modelValue', false);
            self.$emit('afterClose');
        },
        getHHmmStrFromMin( minutesTotal ){
            minutesTotal = minutesTotal || 0;
            const hours = Math.floor(minutesTotal / 60);
            const minutes = minutesTotal % 60;

            let returnStr = hours ? `${hours}H` : "";
            returnStr += minutes ? `${minutes}M` : "";
            returnStr = returnStr || "0H";
            return returnStr;
        },
        getTotalDeductAmount() {
            const self = this;
            
            let total = 0;
            self.deductAmountDetailList.forEach((deduct) => {
                total += deduct.deductAmount;
            });

            return total;
        },
        fitDecimalFormatWithComma : NumberFormatUtil.fitDecimalFormatWithComma,
        fitDateFormat : DateFormatUtil.fitDateFormat,
    }
}
</script>